import { AxiosRequestConfig } from "axios";
import { defaultApi, admissionDatabaseApi } from "./axiosInstance";

// Универсальная фабрика методов для любого axios-инстанса
const makeApiMethods = (axiosInstance: typeof defaultApi) => ({
  get: async <T>(url: string, params?: object, config?: AxiosRequestConfig): Promise<T> => {
    const response = await axiosInstance.get<T>(url, { params, ...config });
    return response.data;
  },

  post: async <T>(url: string, body?: any, config?: AxiosRequestConfig): Promise<T> => {
    const response = await axiosInstance.post<T>(url, body, config);
    return response.data;
  },

  put: async <T>(url: string, body?: any, config?: AxiosRequestConfig): Promise<T> => {
    const response = await axiosInstance.put<T>(url, body, config);
    return response.data;
  },

  delete: async <T>(url: string, body?: any, config?: AxiosRequestConfig): Promise<T> => {
    const response = await axiosInstance.delete<T>(url, { data: body, ...config });
    return response.data;
  },
});

// Создаём два отдельных набора методов
export const apiType = {
  main: makeApiMethods(defaultApi),
  admissionDB: makeApiMethods(admissionDatabaseApi),
};
